import { QueryClient } from '@tanstack/react-query';

// Performance-optimized QueryClient with intelligent caching
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 60 * 1000, // 10 minutes - longer for better performance
      gcTime: 30 * 60 * 1000, // 30 minutes - keep data longer in memory
      retry: (failureCount, error: any) => {
        // Smart retry logic - don't retry on 4xx errors except specific ones
        if (error?.status >= 400 && error?.status < 500) {
          return [408, 429].includes(error?.status) && failureCount < 2;
        }
        return failureCount < 3;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
      refetchOnMount: 'always',
      refetchOnReconnect: 'always',
      // Improve performance by reducing unnecessary network calls
      refetchInterval: false,
      // Use network-first strategy for better UX
      networkMode: 'online',
      // Enable background refetching for fresh data
      refetchIntervalInBackground: false,
    },
    mutations: {
      retry: (failureCount, error: any) => {
        // Only retry mutations on network errors, not client errors
        if (error?.status >= 400 && error?.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 5000),
      // Enable optimistic updates by default
      networkMode: 'online',
    },
  },
});